import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "empty-state",
  "data-qa": "empty-state"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "empty-state-message" }
const _hoisted_5 = {
  key: 2,
  class: "link-grid",
  "data-qa": "link-grid"
}
const _hoisted_6 = ["onClick", "onKeydown"]
const _hoisted_7 = { class: "cadre-image" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "icon-wrapper" }
const _hoisted_10 = { class: "link-label" }
const _hoisted_11 = {
  class: "titles",
  "data-qa": "link-label"
}

import { computed, onMounted, onUnmounted, reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { UseStoreUser } from '@/store/userStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'LiensUtilWidget',
  emits: ["onClickPersonnalisation"],
  setup(__props, { emit: __emit }) {

const undrawLink = require('@/assets/images/undraw_link.svg');

const { t } = useI18n();
const userStore = UseStoreUser();
const showDropdown = ref(false);
const dropdownRef = ref<HTMLElement | null>(null);
const isToggling = ref(false);
const isDeleteClick = ref(false);
const emit = __emit;
const data = reactive({
  actions: [
    {
      code: '1',
      text: 'Personnaliser',
      icon: 'actions_vertical',
      callback: customize,
    },
  ],
});

onMounted(() => {
  userStore.fetchUserLinks();
  document.addEventListener('click', handleClickOutside);
});

onMounted(() => {
  const icons = document.querySelectorAll('.cs-button-icon[role="img"]');

  icons.forEach(icon => {
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('role', 'presentation');
  });
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

function handleCardClick(event: MouseEvent, url: string) {
  if (isDeleteClick.value == true) {
    isDeleteClick.value = false;
    return;
  }
  openLink(url);
}

function handleDropdown(event?: Event) {
  isToggling.value = true;
  showDropdown.value = !showDropdown.value;

  // Reset the toggle flag after a short delay
  setTimeout(() => {
    isToggling.value = false;
  }, 100);
}
function cancelDelete() {
  linkToDelete.value = null;
  isDeleteClick.value = false;
}
function handleClickOutside(event: MouseEvent) {
  // Don't close if we're currently toggling
  if (isToggling.value) {
    return;
  }

  const target = event.target as Node;

  // Don't close if clicking on the dropdown itself
  if (dropdownRef.value && dropdownRef.value.contains(target)) {
    return;
  }

  // Close dropdown if clicking outside
  showDropdown.value = false;
}

function customize() {
  emit('onClickPersonnalisation');
  showDropdown.value = false;
}
function openLink(url: string) {
  window.open(url, '_blank', 'noopener,noreferrer');
}
const hasNoLinks = computed(() => !userStore.userLinks || userStore.userLinks.length === 0);
const linkToDelete = ref<string | null>(null);

function confirmDelete(linkId: string): void {
  userStore.deleteUserLink(linkId);
  isDeleteClick.value = false;
  linkToDelete.value = null;
}

return (_ctx: any,_cache: any) => {
  const _component_cs_confirmation_popup = _resolveComponent("cs-confirmation-popup")!
  const _component_cs_button = _resolveComponent("cs-button")!
  const _component_cs_link = _resolveComponent("cs-link")!
  const _component_cs_widget = _resolveComponent("cs-widget")!

  return (_openBlock(), _createBlock(_component_cs_widget, {
    title: _unref(t)('dashboard.lienUtilTitle'),
    class: _normalizeClass(['my-wrap', { 'no-overflow': hasNoLinks.value }]),
    actions: data.actions
  }, {
    default: _withCtx(() => [
      (isDeleteClick.value == true)
        ? (_openBlock(), _createBlock(_component_cs_confirmation_popup, {
            key: 0,
            class: "confirmation-popup-delete",
            "data-qa": "confirmation-popup-delete",
            "is-opened": true,
            onConfirmation: _cache[0] || (_cache[0] = (result) => {
    if (result && linkToDelete.value) {
      confirmDelete(linkToDelete.value)
    }
    cancelDelete()
  })
          }, {
            importantMessage: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _unref(t)('modal.confirmDeleteLien')
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (hasNoLinks.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _unref(undrawLink),
              alt: _unref(t)('links.noLinksImageAlt'),
              class: "empty-state-image"
            }, null, 8, _hoisted_3),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('links.noLinksMessage')), 1),
            _createVNode(_component_cs_button, {
              text: _unref(t)('links.addLink'),
              icon: "ajouter",
              type: "secondary",
              "data-qa": "add-link-button",
              onClick: customize
            }, null, 8, ["text"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).userLinks, (link, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "link-card",
                key: link.id,
                onClick: ($event: any) => (handleCardClick($event, link.url)),
                tabindex: "0",
                role: "link",
                onKeydown: _withKeys(($event: any) => (openLink(link.url)), ["enter"])
              }, [
                _createElementVNode("div", _hoisted_7, [
                  (link.imageBase64)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: link.imageBase64,
                        "data-qa": "link-img",
                        alt: link.name,
                        class: "link-image"
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    (link && !link.isAddedByAdmin)
                      ? (_openBlock(), _createBlock(_component_cs_button, {
                          key: 0,
                          icon: "supprimer",
                          type: "tertiary",
                          size: "small",
                          status: "destructive",
                          class: "link-icon",
                          onClick: _withModifiers(
                () => {
                  isDeleteClick.value = true;
                  linkToDelete.value = link.id;
                }
              , ["stop","prevent"]),
                          "aria-label": _unref(t)('links.deleteLink', { name: link.name }),
                          title: _unref(t)('links.deleteLink', { name: link.name })
                        }, null, 8, ["onClick", "aria-label", "title"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_cs_link, {
                    "data-qa": "link-url",
                    link: `${link.url}`,
                    "is-external-link": "",
                    target: "_blank",
                    "aria-label": _unref(t)('links.openLinkNewWindow', { name: link.name })
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("b", _hoisted_11, _toDisplayString(link.name), 1),
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "visually-hidden" }, "(nouvelle fenêtre)", -1))
                    ]),
                    _: 2
                  }, 1032, ["link", "aria-label"])
                ])
              ], 40, _hoisted_6))
            }), 128))
          ]))
    ]),
    _: 1
  }, 8, ["title", "class", "actions"]))
}
}

})